import styled from 'styled-components';

import { media } from 'helpers/breakpoints';

interface ViewProps {
  isGrid?: boolean;
}

const Title = styled.p<ViewProps>`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  ${({ isGrid, theme }) => (isGrid ? theme.fontSize.B12 : theme.fontSize.L18)};
  overflow: hidden;
  word-break: break-word;

  @supports (-webkit-line-clamp: 2) {
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  ${media.medium} {
    ${({ theme }) => theme.fontSize.L18};
  }
`;

const KeyInfoList = styled.ul`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const KeyInfoItem = styled.li<ViewProps>`
  ${({ isGrid, theme }) => (isGrid ? theme.fontSize.B12 : theme.fontSize.M14)};
  list-style: none;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.GREY_DARK};

  &:after {
    width: 4px;
    height: 4px;
    background: ${({ theme }) => theme.colors.GREY};
    margin-left: ${({ theme }) => theme.spacing.S8};
    margin-right: ${({ theme }) => theme.spacing.S8};
    content: '';
    border-radius: 50%;
  }

  &:last-child {
    &:after {
      width: ${({ theme }) => theme.spacing.S4};
      content: none;
      height: 100%;
    }
  }

  ${media.medium} {
    ${({ theme }) => theme.fontSize.M14}
  }
`;

export { Title, KeyInfoList, KeyInfoItem };
